import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { ConnectionService } from '@services/connection-service';

/**
 * Existing users should not see the location onboarding page again.
 * Returning a UrlTree lets Angular redirect before the component is activated.
 */
export const onboardingLocationGuard: CanActivateFn = (): boolean | UrlTree => {
  const connectionService = inject(ConnectionService);
  const router = inject(Router);
  const user = connectionService.getActingUser();

  return user?.get('PrivateMainConcern')
    ? router.createUrlTree(['/user'], { queryParams: { tab: 'home' } })
    : true;
};
